import React from "react";
import { reportClientError } from "../lib/clientLog";

// Catches render-time errors anywhere below it, reports them to the server,
// and shows a fallback instead of a blank white screen.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      type: "react-error-boundary",
      message: (error && (error.message || error.toString())) || "React render error",
      detail: {
        stack: error && error.stack,
        componentStack: info && info.componentStack,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: "24px", textAlign: "center", color: "#464749" }}>
            Something went wrong. Please refresh the page, and contact support if
            the problem continues.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
